import { observable } from 'mobx'

export default class Store {
  @observable
  menus = [
    {
      food_name: []
      //drink_name: [],
    }
  ]

  addMenu = () => {
    this.menus.push({
      food_name: []
      //drink_name: [],
    })
  }

  addDish = (i, dishName) => {
    if (typeof dishName === 'string') {
      dishName = dishName.trim()
      this.menus[i].food_name.push(dishName)
    } else {
      this.menus[i].food_name.push(...dishName)
    }
  }

  deleteDish = (menuIndex, dishIndex) => {
    this.menus[menuIndex].food_name.splice(dishIndex, 1)
  }

  // 删除套餐
  deleteMeal = index => () => {
    this.menus.splice(index, 1)
  }
}
